
import { defineComponent, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useI18n } from 'vue-i18n'

import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import LayoutsGuest from '@/layouts/Guest.vue'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import BaseShadowCard from '@/components/BaseShadowCard.vue'
import { ALERT_COLORS } from '@/store/base'
import { Buffer } from 'buffer'

export default defineComponent({
  components: { LayoutsGuest, BaseFormSubmit, BaseShadowCard },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { t } = useI18n()
    const store = useStore()

    const btnDisabled = ref(false)

    const schema = yup.object({
      email: yup.string().required().email().max(255),
      password: yup.string().required().min(8).max(255),
      password_confirmation: yup.string().required().oneOf([yup.ref('password'), null], t('validation.password_confirmation')),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema })

    const { value: email } = useField<string>('email')
    const { value: password } = useField<string>('password')
    const { value: password_confirmation } = useField<string>('password_confirmation')

    onMounted(() => {
      email.value = Buffer.from(route.query.email as string, 'base64').toString()
    })

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/reset-password', {
          email: values.email,
          password: values.password,
          token: route.params.token
        })
        .then(() => {
          store.commit('base/setAlertMessages', { messages: [t('reset_password.success')], persistent: true, color: ALERT_COLORS.info })
          router.push('/login')
        })
        .finally(() => btnDisabled.value = false)
    })

    return {
      t,
      errors,
      email,
      password,
      password_confirmation,
      onSubmit,
      btnDisabled
    }
  },
})
